import React from 'react';
import './CardDestacados.css';
import { Link } from 'react-router-dom';

import soporteTi from '../../../assets/img/formacion-tecnico-laboral/asistencia-soporte-ti.jpeg';
import seguridadTrabajo from '../../../assets/img/formacion-tecnico-laboral/seguridad-trabajo.jpeg';
import asistenteAdministrativo from '../../../assets/img/formacion-tecnico-laboral/asistente-administrativo.jpeg';
import primeraInfancia from '../../../assets/img/formacion-tecnico-laboral/primera-infancia.jpeg';
import artesGraficas from '../../../assets/img/formacion-tecnico-laboral/artes-graficas.jpeg';

const CardDestacados = () => {
  const destacados = [
    {
      slug: 'asistencia-soporte-tecnologia-informacion',
      title: 'Asistencia y Soporte de Tecnología de la Información',
      duration: '3 semestres',
      modality: null,
      image: soporteTi,
    },
    {
      slug: 'auxiliar-seguridad-trabajo',
      title: 'Auxiliar de Seguridad en el Trabajo',
      duration: '3 semestres',
      modality: null,
      image: seguridadTrabajo,
    },
    {
      slug: 'asistente-administrativo',
      title: 'Asistente Administrativo',
      duration: '3 semestres',
      modality: null,
      image: asistenteAdministrativo,
    },
    {
      slug: 'atencion-integral-primera-infancia',
      title: 'Atención Integral a la Primera Infancia',
      duration: '3 semestres',
      modality: 'Presencial',
      image: primeraInfancia,
    },
    {
      slug: 'auxiliar-artes-graficas',
      title: 'Auxiliar de Artes Gráficas',
      duration: '3 semestres',
      modality: null,
      image: artesGraficas,
    },
  ];

  return (
    <section className="destacados-section">
      <h2 className="destacados-title">Destacados</h2>

      <div className="destacados-grid">
        {destacados.map((item, index) => (
          <article key={index} className="destacado-card">
            <div className="destacado-image-wrap">
              <img src={item.image} alt={item.title} className="destacado-image" />
              <span className="destacado-badge">
                DESTACADO
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 2l2.4 7.2H22l-6 4.4 2.3 7.2L12 16.8 5.7 20.8 8 13.6 2 9.2h7.6L12 2z" />
                </svg>
              </span>
            </div>

            <div className="destacado-body">
              <h3 className="destacado-name">{item.title}</h3>
              <p className="destacado-meta">{item.duration}</p>
              <p className="destacado-meta">{item.modality}</p>

              <Link
                className="destacado-btn"
                to={`/formaciontecnicolaboral/${item.slug}`}
              >
                Conoce Mas <span aria-hidden="true">→</span>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CardDestacados;
